// National topper quotes (from Topper-Quotes-12x18 deck). Motivation wall content.
export const TOPPER_QUOTES = [
 {
  "exam": "JEE Advanced",
  "year": 2020,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "what I do is just cut off all the things I do whenever I am not productive",
  "name": "Chirag Falor",
  "source": "chiragfalor.in"
 },
 {
  "exam": "JEE Advanced",
  "year": 2021,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "I focused on giving many mock tests, made short notes, made mistakes copy.",
  "name": "Mridul Agarwal",
  "source": "Educere India interview, 2021"
 },
 {
  "exam": "JEE Advanced",
  "year": 2022,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "it is not the number of hours but the quality that matters",
  "name": "R K Shishir",
  "source": "Zee News, 2022"
 },
 {
  "exam": "JEE Advanced",
  "year": 2023,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "the winning trio of self-discipline, in-depth knowledge grasp, and consistent revision is key to acing any exam",
  "name": "Vavilala Chidvilas Reddy",
  "source": "Careers360 topper interview, 2023"
 },
 {
  "exam": "JEE Advanced",
  "year": 2024,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "I used to study till my goals were not completed",
  "name": "Ved Lahoti",
  "source": "Topper profile interview"
 },
 {
  "exam": "JEE Advanced",
  "year": 2025,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "I never strictly followed a schedule for studies because it creates an unnecessary pressure.",
  "name": "Rajit Gupta",
  "source": "Careers360 topper interview, 2025"
 },
 {
  "exam": "JEE Advanced",
  "year": 2026,
  "rank": "AIR 1",
  "score": "",
  "extra": "",
  "quote": "Nobody can study 18 hours a day. One must not exhaust their energy by overstudying.",
  "name": "Shubham Kumar",
  "source": "Careers360 topper interview, 2026"
 },
 {
  "exam": "JEE Advanced",
  "year": 2025,
  "rank": "AIR 2",
  "score": "",
  "extra": "",
  "quote": "it is important to maintain your cool and calm. Things may not work out as you planned but you must trust your preparation and face the situation.",
  "name": "Saksham Jindal",
  "source": "Careers360 topper interview, 2025"
 },
 {
  "exam": "JEE Advanced",
  "year": 2025,
  "rank": "AIR 13",
  "score": "",
  "extra": "",
  "quote": "Test analysis is more important than scoring marks in the test.",
  "name": "Vedansh Garg",
  "source": "Careers360 topper interview, 2025"
 },
 {
  "exam": "JEE Advanced",
  "year": 2025,
  "rank": "AIR 80",
  "score": "",
  "extra": "",
  "quote": "Anyone can study when they are motivated, but it’s discipline that truly sets you apart.",
  "name": "Divyanth Jayakumar",
  "source": "Careers360 topper interview, 2025"
 },
 {
  "exam": "JEE Advanced",
  "year": 2025,
  "rank": "AIR 78",
  "score": "",
  "extra": "",
  "quote": "It’s not about how much time you study, it’s about how much interest you show while studying.",
  "name": "Korikana Rasagnya",
  "source": "Careers360 topper interview, 2025"
 },
 {
  "exam": "JEE Advanced",
  "year": 2024,
  "rank": "AIR 6",
  "score": "",
  "extra": "",
  "quote": "the best strategy is no strategy",
  "name": "Rajdeep Mishra",
  "source": "Careers360 topper interview, 2024"
 },
 {
  "exam": "JEE Advanced",
  "year": 2023,
  "rank": "AIR 15",
  "score": "",
  "extra": "",
  "quote": "Maintaining the error analysis notebook helped me to go back and revise things perfectly — it makes it easy to know where we lost marks previously.",
  "name": "Chaitanya Maheshwari",
  "source": "Careers360 topper interview"
 },
 {
  "exam": "JEE Advanced",
  "year": 2023,
  "rank": "AIR 11",
  "score": "",
  "extra": "",
  "quote": "it is essential not to be discouraged if you commence your preparation in 11th grade, as I did. Success is still within reach",
  "name": "Ujwal L Shankar",
  "source": "Careers360 topper interview, 2023"
 },
 {
  "exam": "JEE Advanced",
  "year": 2020,
  "rank": "AIR 6",
  "score": "",
  "extra": "",
  "quote": "The key to a good outcome is to keep working on your mistakes and misconceptions irrespective of the circumstances around you.",
  "name": "Hardik Rajpal",
  "source": "Careers360 topper interview"
 },
 {
  "exam": "JEE Advanced",
  "year": 2023,
  "rank": "AIR 13",
  "score": "",
  "extra": "",
  "quote": "I took no additional study material as it only complexes the preparation",
  "name": "Yuvraj Gupta",
  "source": "Careers360 topper interview"
 },
 {
  "exam": "JEE Main",
  "year": 2017,
  "rank": "AIR 1",
  "score": "360/360",
  "extra": "",
  "quote": "Reading theory is important, but practice makes perfect. The exam is all about solving problems",
  "name": "Kalpit Veerwal",
  "source": "kalpitveerwal22.blogspot.com"
 },
 {
  "exam": "JEE Main",
  "year": 2024,
  "rank": "100 Percentile",
  "score": "",
  "extra": "",
  "quote": "Never sacrifice your sleep.",
  "name": "Himanshu",
  "source": "Careers360 topper interview"
 },
 {
  "exam": "NEET",
  "year": 2026,
  "rank": "AIR 1",
  "score": "715/720",
  "extra": "",
  "quote": "Every line of the NCERT textbook is important. I revised NCERT multiple times and memorized almost everything.",
  "name": "Aryan Gupta",
  "source": "Careers360, Manisha Tiwari, 19 July 2026"
 },
 {
  "exam": "NEET",
  "year": 2026,
  "rank": "AIR 2",
  "score": "715/720",
  "extra": "",
  "quote": "Strictly follow NCERT. I don't think any additional book is necessary for Biology.",
  "name": "Panshul Bansal",
  "source": "Careers360, Manisha Tiwari, 17 July 2026"
 },
 {
  "exam": "NEET",
  "year": 2025,
  "rank": "AIR 1",
  "score": "686/720",
  "extra": "",
  "quote": "Whenever my marks fluctuated, whether they were high or low, I used to talk to my parents and my mentor. He always reminded me that we shouldn't judge ourselves based on marks alone, especially not just the ones we score in qualifying tests. The focus should always be on consistent effort and improvement.",
  "name": "Mahesh Kumar",
  "source": "Careers360, Sonia Vats, 14 June 2025"
 },
 {
  "exam": "NEET",
  "year": 2025,
  "rank": "AIR 3",
  "score": "",
  "extra": "",
  "quote": "I still can't believe I secured rank three. The exam was hard (and) I expected to get a rank of nine or ten but never dreamt of three. It is not always the hard work; luck also plays an important factor.",
  "name": "Krishang Joshi",
  "source": "ThePrint, 'Meet NEET UG 2025 toppers…', Udit Bubna, 15 June 2025"
 },
 {
  "exam": "NEET",
  "year": 2025,
  "rank": "AIR 5",
  "score": "",
  "extra": "Top-ranked girl",
  "quote": "I cannot believe I am the female topper of NEET UG.",
  "name": "Avika Aggarwal",
  "source": "ThePrint, Udit Bubna, 15 June 2025"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "Nagpur",
  "quote": "I used to study till whatever time it was in the night, but I made sure that I got enough sleep. I used to sleep only after completing my daily target. On average, I used to study for 8 hours per day.",
  "name": "Ved Sunil Kumar Shinde",
  "source": "Careers360, 'NEET 2024 Topper AIR 1 Ved Sunil Kumar Shinde Interview', 5 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "I have always been fascinated with Biology and wanted to study more of it.",
  "name": "Mridul Manya Anand",
  "source": "Careers360, 5 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "I used to take one NEET mock test daily which helped me feel better on the exam day.",
  "name": "Hritik Raj",
  "source": "Careers360, 5 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "I used to give mock tests and evaluate the questions in which I used to make mistakes.",
  "name": "Aditya Kumar Panda",
  "source": "Careers360, 'NEET 2024 Topper Interview AIR 1 Aditya Kumar Panda', 7 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "My exam day strategy is to keep calm and not let the exam stress take over my brain. Also to complete the questions I find easy at the first and the hard ones at the end.",
  "name": "Taijas Singh",
  "source": "Careers360, 4 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2024,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "Eventually, I overcame the challenges in Physics and Chemistry with regular study and practising the NEET NCERT syllabus.",
  "name": "Palansha Agarwal",
  "source": "Careers360, 6 June 2024"
 },
 {
  "exam": "NEET",
  "year": 2023,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "The quality study with focus and understanding is more important than the number of hours put in.",
  "name": "Bora Varun Chakravarthi",
  "source": "Careers360, 'NEET UG 2023 Result: \"Aspire to serve humanity\"…', Team Careers360, 14 June 2023"
 },
 {
  "exam": "NEET",
  "year": 2023,
  "rank": "AIR 3",
  "score": "716/720",
  "extra": "",
  "quote": "please keep giving mock tests when exams are near. By giving mock tests, you can know where you are making mistakes",
  "name": "Kaustav Bauri",
  "source": "Careers360, 'NEET 2023 Topper Kaustav Bauri Interview AIR 3', 1 September 2023"
 },
 {
  "exam": "NEET",
  "year": 2022,
  "rank": "AIR 1",
  "score": "715/720",
  "extra": "",
  "quote": "A month before my exam, I exceeded my self-study hours from 5-6 to 10-12.",
  "name": "Tanishka",
  "source": "Careers360, Sonia Vats, 8 September 2022"
 },
 {
  "exam": "NEET",
  "year": 2022,
  "rank": "AIR 2",
  "score": "",
  "extra": "",
  "quote": "Keeping your preparation consistent is essential. At times you'll inevitably be low, and at other times you'll be very positive, but don't get overconfident.",
  "name": "Vatsa Ashish Batra",
  "source": "Careers360, updated 2 February 2024"
 },
 {
  "exam": "NEET",
  "year": 2022,
  "rank": "AIR 3",
  "score": "",
  "extra": "",
  "quote": "Mistakes are natural. The important thing is to learn from them.",
  "name": "Hrishikesh N. Gangule",
  "source": "Careers360, 10 September 2022"
 },
 {
  "exam": "NEET",
  "year": 2021,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "In the last month, I was more focussed to giving more NEET mock tests for the full syllabus. It was NCERT text book revision and giving mock tests.",
  "name": "Tanmay Gupta",
  "source": "Careers360, updated 29 August 2023"
 },
 {
  "exam": "NEET",
  "year": 2021,
  "rank": "AIR 1",
  "score": "720/720",
  "extra": "",
  "quote": "Instead of trying to keep up with a detailed schedule and failing at it, I decided to do what suits my limitations.",
  "name": "Mrinal Kutteri",
  "source": "Careers360 News, R. Radhika, 3 November 2021"
 }
];

export const quoteOfTheDay = (exam) => {
  const pool = exam ? TOPPER_QUOTES.filter((q) => q.exam.startsWith(exam)) : TOPPER_QUOTES;
  const day = Math.floor(Date.now() / 86400000);
  return pool[day % pool.length];
};
